<template>
    <div>
        <el-dialog :close-on-click-modal="false" title="导入excel文件" append-to-body v-bind="$attrs"  v-on="$listeners">
            <el-form  label-width="120px">
                <el-form-item v-auth="'shangchuanExcelTemplate'" label="上传模板：">
                    <brupload
                            :refid="refId"
                            :reftype="refType"
                            uploadflag
                            delflag
                    />
                </el-form-item>
                <el-form-item label="获取Bom信息：">
                    <el-button size="small" type="primary" @click="getBom">获取Bom<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-form-item>
                <el-form-item label="点击下载模板：">
                    <li v-for="o,i in this.fileList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                        <a class="el-upload-list__item-name" v-down="o.id"><i
                                class="el-icon-document"></i>{{o.name}}
                        </a>
                    </li>
                </el-form-item>
                <el-form-item>
                    <el-upload
                            class="upload-demo"
                            action=""
                            :before-upload="beforeUpload"
                            multiple  >
                        <el-button size="small" type="primary">导入EXCEL<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="提示内容："  >
                    <div style="width:98%;border:1px solid #ccc;height:100px;padding: 3px;">
                        {{msg}}
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="callback">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    import reformService from "../../api/reform/reformService";
    import updownfile from "../../utils/updownfile";
    export default {
        props:{
            refid:null,
            reftype:null,
            clsname:null,
            startrow:{
                type: Number,
                default: 0
            },
            extparams:{},
        },
        data(){
          return {
              fileList: [],
              resultdata:null,
              msg:null,
          }
        },
        mounted(){
            uploaddown.listdownfile({refid:this.refId, reftype: this.refType}).then(rd => {
                if(rd.obj && rd.obj.length>0){
                    this.fileList.push(rd.obj[rd.obj.length-1])
                }
            })
        },
        computed: {
            clsName:function(){
                return this.clsname;
            },
            startRow:function () {
                return this.startrow;
            },
            refId:function () {
                return this.refid||this.clsname;
            },
            refType:function () {
                return this.reftype||this.clsname;
            },
            extParams:function () {
                return this.extparams;
            },
        },
        methods: {
            beforeUpload(file){
                uploaddown.importExcel(file, {clsname: this.clsName, startrow: this.startRow,extparams:this.extParams }).then(rd => {
                    this.resultdata = rd;
                    if(rd.f){
                        this.msg=rd.msg||"导入成功！"
                    }else{
                        this.$msg.msge("导入出错！");
                        this.msg=rd.msg;
                    }
                }).catch(error=>{
                    return Promise.reject(error);
                })
                return false;
            },
            callback(){
                this.$emit("callback",this.resultdata)
                this.$emit("update:visible",false)
            },
            getBom(){
                console.log("bom",this.extParams)
                if(this.extParams.MATNR == null || this.extParams.MATNR == ''){
                    this.$msg.msge("请选择物料！");
                    return;
                }
                if(this.extParams.number == null || this.extParams.number == ''){
                    this.$msg.msge("请填写数量！");
                    return;
                }
                var data = {
                    factory: this.extParams.WERKS,
                    materialCode: this.extParams.MATNR,
                    number:this.extParams.number
                }
                updownfile.down('/api/swyl/v1/reform/reformMainSap/downloadExcelBom',data,"get");
            }
        },
    }
</script>
